import { useCallback } from 'react';

import { useNewUserAccessRights, useWindowSize } from '@app/hooks';
import { useHeader } from '@app/providers';

export const useSubscriptionsPageHeader = () => {
  const {
    userAccessRights: { Clients },
  } = useNewUserAccessRights();

  const { isMobile } = useWindowSize();
  const { header } = useHeader();

  // Открытие модалки публикует страница реестра через HeaderContext
  const openCreateModal = useCallback(() => {
    const { openSubscriptionModal } = header;

    if (typeof openSubscriptionModal === 'function') {
      openSubscriptionModal();
    }
  }, [header]);

  return {
    canCreate: Boolean(Clients?.IsEdit),
    isMobile,
    openCreateModal,
  };
};
